<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
      inline
    >
      <FormItem label="机构名称" prop="organName">
        <Input class="w-250" v-model="editModel.organName"></Input>
      </FormItem>
      <FormItem label="机构编号" prop="organCode">
        <Input class="w-250" v-model="editModel.organCode"></Input>
      </FormItem>

      <FormItem label="机构类型" prop="organType">
        <Select class="w-250" v-model="editModel.organType" clearable>
          <Option
            v-for="(item, index) in organTypeSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="机构英文名称">
        <Input class="w-250" v-model="editModel.organNameEN"></Input>
      </FormItem>
      <FormItem label="机构电话">
        <Input class="w-250" v-model="editModel.organTell"></Input>
      </FormItem>
      <FormItem label="机构地址">
        <Input class="w-250" v-model="editModel.organAddress"></Input>
      </FormItem>
      <FormItem label="经度">
        <Input class="w-250" v-model="editModel.organLongitude"></Input>
      </FormItem>
      <FormItem label="纬度">
        <Input class="w-250" v-model="editModel.organLatitude"></Input>
      </FormItem>
      <FormItem label="备注">
        <Input
          class="w-250"
          v-model="editModel.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        ></Input>
      </FormItem>
      <FormItem label="选择行政区">
        <v-region
          :town="true"
          @values="regionChange"
          v-model="address"
        ></v-region>
      </FormItem>
      <!-- <FormItem label="上级机构">
        <Button type="success" @click="treeModel=true">选择上级机构</Button>
        <span class="ml-5">{{organParentName}}</span>
      </FormItem>-->
    </Form>
    <div class="edit_btn_group">
      <Button class="mr-5" @click="returnBack">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')" >确 定</Button>
    </div>
    <Modal v-model="treeModel" title="选择上级机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

import { RegionSelects } from 'v-region'
export default {
  components: { organTree,RegionSelects },
  data: function () {
    return {
      organTypeSelect: [],
      treeModel: false,
      organParentName: "",
      address: {
        province: "",
        city: "",
        area: "",
        town: "",
      },
      editModel: {
        organID: "",
        organName: "",
        organCode: "",
        organType: "",
        organTell: "",
        organAddress: "",
        remark: "",
        organParentID: "",
        province: "",
        city: "",
        area: "",
        town: "",
        organLongitude: "",
        organLatitude: ""
      },
      ruleValidate: {
        organName: [
          {
            required: true,
            message: "机构名称不能为空",
          },
        ],
        organCode: [
          {
            required: true,
            message: "机构编号不能为空",
          },
        ],
        organType: [
          {
            required: true,
            message: "机构类型不能为空",
          },
        ],
      },
    };
  },

  activated: function () {
    this.$common.getDictionary("机构类型").then((data) => {
      this.organTypeSelect = data;
    });
    this.initData(this.$route.query.id);
  },

  methods: {
    returnBack: function () {
      this.$router.push("organ");
    },

    initData(id) {
      this.$api.get(`organ/GetById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          // this.$set(this,'editModel',rsp.data)
          this.editModel = rsp.data.item1;
          this.address.province = this.editModel.province;
          this.address.city = this.editModel.city;
          this.address.area = this.editModel.area;
          this.address.town = this.editModel.town;
        }
      });
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("organ/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
            }
          });
        }
      });
    },

    selectTreeData: function (data) {
      this.editModel.OrganParentID = data[0].organID;
      this.organParentName = data[0].title;
    },
    regionChange(data) {
      console.log(data,48);
      this.editModel.province = data.province ? data.province.key : "";
      this.editModel.city = data.city ? data.city.key : "";
      this.editModel.area = data.area ? data.area.key : "";
      this.editModel.town = data.town ? data.town.key : "";
      this.editModel.organAddress = data.province ? data.province.value : ''
    },
  },
};
</script>